export default {
  SET_DOCUMENTS(state, documents) {
    state.documents = documents
  },
  SET_SUMMARY(state, summary) {
    state.summary = summary
  },
  SET_FULL_SUMMARY(state, fullSummary) {
    state.fullSummary = fullSummary
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = pagination
  },
  SET_HAS_DOCUMENTS(state, hasDocuments) {
    state.hasDocuments = hasDocuments
  },
}

